'use client';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { ProductDetail } from '@nettbureau/featured-core';
import {
  Focusable,
  HStack,
  Icon,
  Rectangle,
  Text,
  Tooltip,
  TooltipTrigger,
} from '@nettbureau/vibrant-ui';
import { DynamicIcon, DynamicIconProps } from '../shared/DynamicIcon';

interface Props {
  detail: ProductDetail;
}

export function ProductCardDetail({ detail }: Props) {
  return (
    <Rectangle
      data-featured-product-detail-wrapper
      key={detail.key}
      fill="gray"
      fillTone={50}
      borderRadius="sm"
    >
      <HStack justify="space-between" align="center" padding="xs" width="100%">
        <HStack align="center" gap="xs">
          {detail.icon && (
            <DynamicIcon
              iconName={detail.icon as DynamicIconProps['iconName']}
            />
          )}

          <Text data-featured-product-detail-key size="sm" color="gray">
            {detail.key}:
          </Text>
        </HStack>

        <HStack align="center" gap="2xs">
          <Text data-featured-product-detail-value size="sm" color="gray">
            {detail.value}
          </Text>

          {detail.moreInfo && (
            <TooltipTrigger>
              <Focusable>
                <Icon size="xs" icon={faCircleInfo}></Icon>
              </Focusable>

              <Tooltip data-featured-product-tooltip placement="top left">
                {detail.moreInfo}
              </Tooltip>
            </TooltipTrigger>
          )}
        </HStack>
      </HStack>
    </Rectangle>
  );
}
